
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "CriteriaOfNFIAndNFII",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/CriteriaOfNFIAndNFII.vue